import { render, staticRenderFns } from "./BlockEditorDemo.vue?vue&type=template&id=75d90f5f&scoped=true&"
import script from "./BlockEditorDemo.vue?vue&type=script&lang=js&"
export * from "./BlockEditorDemo.vue?vue&type=script&lang=js&"
import style0 from "./BlockEditorDemo.vue?vue&type=style&index=0&id=75d90f5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d90f5f",
  null
  
)

export default component.exports